import { ProductStatus } from "../@types/enums/ProductStatus";
export function getProductStatus(product) {
    if (product.in_stock) {
        return ProductStatus["InStock"];
    }
    return product.discontinued ? ProductStatus["Discontinued"] : ProductStatus["OutOfStock"];
}
//# sourceMappingURL=utils.js.map